import {makeSplitPoint} from 'plugins/react'

export default {
	label: 'Contact form',
	group: 'forms',
	Value: makeSplitPoint(() => import('./ContactSection')),
	Form: makeSplitPoint(() => import('./ContactForm'), {ssr: false}),
}
